<div class="user-management-page">
  <div id="user-info-table" class="cam-table mic-table mt-4">
    <mat-card class="search-card">
      <form
        [formGroup]="form"
        class="filters flex flex-row justify-center items-start sm-flex-col gap-4 searcn-form user-management-filters"
      >
        <mat-form-field class="search-by-name-input editable-field" subscriptSizing="dynamic">
          <mat-label>{{ translationService.translate('searchByNameText') }}</mat-label>
          <input
            matInput
            formControlName="name"
            name="name"
            placeholder="{{ translationService.translate('enterFirstLastLoginPlaceHolderText') }}"
            autocomplete="off"
          />
          <button id="search-icon-name" disabled mat-icon-button matSuffix>
            <mat-icon>search</mat-icon>
          </button>
        </mat-form-field>
        <app-dropdown-search-single-select
          id="user-group-input"
          class="search-by-user-group editable-field"
          [formGroup]="form"
          label="{{ translationService.translate('UserGroupFilterLabelText') }}"
          placeholder="{{ translationService.translate('UserGroupPlaceholderText') }}"
          emptyPlaceholder="{{ translationService.translate('UserGroupSearchPlaceholderText') }}"
          searchPlaceholder="{{ translationService.translate('SearchText') }}"
          subscriptSizing="dynamic"
          attribute="groupName"
          formControlName="userGroup"
          [data]="groups"
          name="userGroup"
        >
        </app-dropdown-search-single-select>
        <mat-form-field class="editable-field" subscriptSizing="dynamic">
          <mat-label>{{ translationService.translate('searchByStatusText') }}</mat-label>
          <mat-select
            placeholder="{{ translationService.translate('enterStatusPlaceHolderText') }}"
            formControlName="status"
            name="status"
            autocomplete="off"
          >
            <mat-option value="Y">{{ translationService.translate('activeText') }}</mat-option>
            <mat-option value="N">{{ translationService.translate('inactiveText') }}</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field class="editable-field" subscriptSizing="dynamic">
          <mat-label>{{ translationService.translate('searchByBTMIdText') }}</mat-label>
          <input
            matInput
            formControlName="btmId"
            name="btmId"
            placeholder="{{ translationService.translate('enterBTMIdPlaceHolderText') }}"
            autocomplete="off"
          />
          <button id="search-icon-btmId" disabled mat-icon-button matSuffix>
            <mat-icon>search</mat-icon>
          </button>
        </mat-form-field>
        <div class="flex flex-row flex-1 gap-4 justify-end user-management-actions">
          <button
            id="reset-filters"
            (click)="resetFilters()"
            mat-flat-button
            color="accent"
            class="mic-btn-icon-left reset-filter btn-clear"
            aria-label="reset filters"
          >
            <mat-icon role="img" aria-label="restart_alt">refresh</mat-icon>
            {{ translationService.translate('clearSelectionText') }}
          </button>
          @if (hasRolePermission(ROLES.edit_user)) {
          <button
            id="add-user"
            (click)="addUser()"
            mat-flat-button
            color="primary"
            class="mic-btn-icon-left add-user btn-primary"
            aria-label="add user"
          >
            <mat-icon role="img" aria-label="restart_alt">add_circle_outline</mat-icon>
            {{ translationService.translate('addUserText') }}
          </button>
          }
        </div>
      </form>
    </mat-card>

    <div class="table-wrapper">
      <mic-table appCopyOnSelect #paginatedTable class="table-stripped" [config]="tableConfig" [fetcher]="fetcher" [filtersConfig]="">
        <ng-container *micTableNoData>
          <mic-empty-state icon="layers_clear" title="{{ translationService.translate('emptyTableText') }}"></mic-empty-state>
        </ng-container>
        <ng-container *micTableColumnSelector>
          <button mat-flat-button class="column-button">
            <mat-icon>view_column</mat-icon>
            {{ translationService.translate('columnsButtonText') }}
          </button>
        </ng-container>
        <ng-container *micCellTemplate="let item; name: 'activeCell'">
          <div class="flex flex-row gap-1">
            @if (item.active_Flg === 'Y') {
            <mic-status class="valid">{{ translationService.translate('activeText') }}</mic-status>
            } @if (item.active_Flg === 'N') {
            <mic-status>{{ translationService.translate('inactiveText') }}</mic-status>
            }
          </div>
        </ng-container>
        <ng-container *micCellTemplate="let item; name: 'userLockedCell'">
          <div class="flex flex-row gap-1">
            @if (isAccountLocked(item.account_Locked_Date)) {
            <mic-status>{{ translationService.translate('noText') }}</mic-status>
            } @if (!isAccountLocked(item.account_Locked_Date)) {
            <mic-status>{{ translationService.translate('yesText') }}</mic-status>
            }
          </div>
        </ng-container>
        <ng-container *micCellTemplate="let item; name: 'userExpiredCell'">
          <div class="flex flex-row gap-1">
            @if (isPasswordExpired(item.password_dt)) {
            <mic-status>{{ translationService.translate('yesText') }}</mic-status>
            } @if (!isPasswordExpired(item.password_dt)) {
            <mic-status>{{ translationService.translate('noText') }}</mic-status>
            }
          </div>
        </ng-container>
        <ng-container *micTableRowMenu="let data">
          <button mat-menu-item class="user-actions-menu-item" id="unlock-button" (click)="unlockUserAccount(data)">
            <mat-icon>lock_open</mat-icon>
            <span class="user-actions-menu-label">{{ translationService.translate('unlockUserText') }}</span>
          </button>
          <button mat-menu-item class="user-actions-menu-item" id="reset-password-button" (click)="showResetPasswordModal(data)">
            <mat-icon>lock_reset</mat-icon>
            <span class="user-actions-menu-label">{{ translationService.translate('resetPasswordText') }}</span>
          </button>
          <!-- The following button is commented out to hide the deactivate user functionality -->
          <!-- <button mat-menu-item id="cancel-button">
          <mat-icon>lock_person</mat-icon>
          <span style="font-weight: bolder">{{ translationService.translate('deActivateUserText') }}</span>
        </button> -->
        </ng-container>
      </mic-table>
    </div>

    <div class="mobile-user-cards" role="list" [attr.aria-label]="translationService.translate('usersText')">
      @if (users.length === 0) {
      <mic-empty-state icon="layers_clear" title="{{ translationService.translate('emptyTableText') }}"></mic-empty-state>
      } @for (item of users; track item.username) {
      <mat-card class="mobile-user-card" role="listitem">
        <div class="mobile-user-card-row">
          <span class="mobile-user-card-label">{{ translationService.translate('loginButtonText') }}</span>
          <span class="mobile-user-card-value">{{ item.username }}</span>
        </div>
        <div class="mobile-user-card-row">
          <span class="mobile-user-card-label">{{ translationService.translate('firstNameText') }}</span>
          <span class="mobile-user-card-value">{{ item.firstName }}</span>
        </div>
        <div class="mobile-user-card-row">
          <span class="mobile-user-card-label">{{ translationService.translate('lastNameText') }}</span>
          <span class="mobile-user-card-value">{{ item.lastName }}</span>
        </div>
        <div class="mobile-user-card-row">
          <span class="mobile-user-card-label">{{ translationService.translate('userGroupText') }}</span>
          <span class="mobile-user-card-value">{{ item.userGroupName }}</span>
        </div>
        <div class="mobile-user-card-row">
          <span class="mobile-user-card-label">{{ translationService.translate('statusColumnText') }}</span>
          <span class="mobile-user-card-value">
            @if (item.active_Flg === 'Y') {
            <mic-status class="valid">{{ translationService.translate('activeText') }}</mic-status>
            } @if (item.active_Flg === 'N') {
            <mic-status>{{ translationService.translate('inactiveText') }}</mic-status>
            }
          </span>
        </div>
        <div class="mobile-user-card-row">
          <span class="mobile-user-card-label">{{ translationService.translate('userLockedText') }}</span>
          <span class="mobile-user-card-value">
            <mic-status>{{ translationService.translate(isAccountLocked(item.account_Locked_Date) ? 'noText' : 'yesText') }}</mic-status>
          </span>
        </div>
        <div class="mobile-user-card-row">
          <span class="mobile-user-card-label">{{ translationService.translate('userPasswordExpiredText') }}</span>
          <span class="mobile-user-card-value">
            <mic-status>{{ translationService.translate(isPasswordExpired(item.password_dt) ? 'yesText' : 'noText') }}</mic-status>
          </span>
        </div>
        <div class="mobile-user-card-row">
          <span class="mobile-user-card-label">{{ translationService.translate('btmIdText') }}</span>
          <span class="mobile-user-card-value">{{ item.btmId }}</span>
        </div>
        <div class="mobile-user-card-actions">
          @if (hasRolePermission(ROLES.view_user) || hasRolePermission(ROLES.edit_user)) {
          <button
            mat-flat-button
            type="button"
            color="primary"
            class="btn-primary"
            (click)="navigateToUser(item)"
            [attr.aria-label]="translationService.translate(hasRolePermission(ROLES.edit_user) ? 'editLinkText' : 'viewText')"
          >
            {{ translationService.translate(hasRolePermission(ROLES.edit_user) ? 'editLinkText' : 'viewText') }}
          </button>
          }
          <button
            mat-flat-button
            type="button"
            class="btn-primary"
            (click)="showResetPasswordModal(item)"
            [attr.aria-label]="translationService.translate('resetPasswordText')"
          >
            {{ translationService.translate('resetPasswordText') }}
          </button>
          <button
            mat-flat-button
            type="button"
            class="btn-primary"
            (click)="unlockUserAccount(item)"
            [attr.aria-label]="translationService.translate('unlockUserText')"
          >
            {{ translationService.translate('unlockUserText') }}
          </button>
        </div>
      </mat-card>
      }
    </div>
  </div>
</div>

<mic-modal class="modalC" #resetPasswordModal (result)="onResetPasswordModalClosed($event)"></mic-modal>
<ng-template #resetPasswordConfirmation>
  <p [innerHTML]="resetPasswordText"></p>
</ng-template>
